import {
  isValidEmail,
  EMAIL_MAX_LENGTH,
} from '@Utils/EmailSanitizerAndValidator'

export const PASSWORD_MAX_LENGTH = 100
export const PASSWORD_MIN_LENGTH_SIGN_UP = 8 // Has been increased from 6
export const EMAIL_OR_DOMAIN_MAX_LENGTH = 100

export const validateEmail = (value: string): string => {
  if (!value.trim()) {
    return ''
  }

  if (value.length > EMAIL_MAX_LENGTH) {
    return 'Email must not exceed ' + EMAIL_MAX_LENGTH + ' characters.'
  }

  if (!isValidEmail(value)) {
    return 'Please enter a valid email address (e.g. you@company.com).'
  }

  return ''
}

export const validatePassword = (value: string): string => {
  if (!value) {
    return ''
  }

  if (value.length < PASSWORD_MIN_LENGTH_SIGN_UP) {
    return 'Password must be at least ' + PASSWORD_MIN_LENGTH_SIGN_UP + ' characters long.'
  }

  if (value.length > PASSWORD_MAX_LENGTH) {
    return 'Password must not exceed ' + PASSWORD_MAX_LENGTH + ' characters.'
  }

  return ''
}

export const validateEmailOrDomain = (value: string): string => {
  if (!value.trim()) {
    return ''
  }

  if (value.length > EMAIL_OR_DOMAIN_MAX_LENGTH) {
    return 'Input must not exceed ' + EMAIL_OR_DOMAIN_MAX_LENGTH + ' characters.'
  }

  return ''
}

export const handleBlurField = <T extends object>(
  field: keyof T,
  value: string,
  setTouched: React.Dispatch<React.SetStateAction<Record<string, boolean>>>,
  setErrors: React.Dispatch<React.SetStateAction<T>>,
  validate: (value: string) => string
) => {
  setTouched(function prev(t) {
    return { ...t, [field as string]: true }
  })

  setErrors(function prevErrors(prev) {
    return { ...prev, [field]: validate(value) }
  })
}

export const handleChangeField = <T extends object>(
  field: keyof T,
  value: string,
  touched: Record<string, boolean>,
  setErrors: React.Dispatch<React.SetStateAction<T>>,
  validate: (value: string) => string
) => {
  if (touched[field as string]) {
    setErrors(function prevErrors(prev) {
      return { ...prev, [field]: validate(value) }
    })
  }
}
